import styled from "styled-components"

import { ApiTypes } from "types"
import { ReactComponent as BellSlashIcon } from "assets/svg/notifications/icon-bell-slash.svg"

import { NotificationCard } from "components/common/NotificationCard"
import { Spinner } from "components/common/Spinner"

const NotificationsList = styled.div`
  flex: 1;
  overflow-y: auto;
  min-height: 0;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: var(--surface-3);
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
`

const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 16px;
  min-height: 200px;
`

const EmptyStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
  padding: 48px 16px;
`

const EmptyIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background-color: #e2e8f0;
  border-radius: 50%;

  svg {
    width: 32px;
    height: 32px;
    color: var(--text-secondary);
  }
`

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
  text-align: center;
`

const EmptyTitle = styled.h3`
  font-weight: 400;
  font-size: 20px;
  color: var(--text-secondary);
  margin: 0;
`

const EmptyDescription = styled.p`
  font-size: 16px;
  font-weight: 300;
  color: var(--text-secondary);
  margin: 0;
`

interface NotificationCenterModalListProps {
  notifications: ApiTypes.Model.Notification[]
  isLoading: boolean
  isLoadingMore: boolean
  hasMore: boolean
  onToggleRead: (id: number, isRead: boolean) => void
  onCardClick: () => void
  listRef?: React.RefObject<HTMLDivElement | null>
}

export const NotificationCenterModalList = ({
  notifications,
  isLoading,
  isLoadingMore,
  hasMore,
  onToggleRead,
  onCardClick,
  listRef,
}: NotificationCenterModalListProps) => (
  <NotificationsList ref={listRef}>
    {isLoading && (
      <LoadingWrapper>
        <Spinner />
      </LoadingWrapper>
    )}
    {!isLoading && notifications.length > 0 && (
      <>
        {notifications.map(notification => (
          <NotificationCard
            key={notification.id}
            notification={notification}
            onToggleRead={onToggleRead}
            onCardClick={onCardClick}
          />
        ))}
        {isLoadingMore && hasMore && (
          <LoadingWrapper>
            <Spinner />
          </LoadingWrapper>
        )}
      </>
    )}
    {!isLoading && notifications.length === 0 && (
      <EmptyStateWrapper>
        <EmptyIconWrapper>
          <BellSlashIcon />
        </EmptyIconWrapper>
        <EmptyState>
          <EmptyTitle>No Unread Notifications</EmptyTitle>
          <EmptyDescription>When you will have new notifications, they&apos;ll show up here.</EmptyDescription>
        </EmptyState>
      </EmptyStateWrapper>
    )}
  </NotificationsList>
)
